// SVG time-series chart. Les couleurs d'axes/gridlines passent par les CSS
// variables de thème (rgb(var(--c-...))) pour basculer dark/light.

const W = 500;
const H = 130;
const PAD = { t: 14, r: 55, b: 28, l: 46 };

export function SparklineChart({ points, timestamps, color, yLabel, unit, maxY }) {
  const pw = W - PAD.l - PAD.r;
  const ph = H - PAD.t - PAD.b;
  const n = points.length;

  if (n < 2) {
    return <div className="text-muted-3 text-xs py-4 text-center">Pas assez de données</div>;
  }

  const yMax = maxY != null ? maxY : 100;
  const xp = (i) => PAD.l + (i / (n - 1)) * pw;
  const yp = (v) => PAD.t + (1 - Math.min(Math.max(v, 0), yMax) / yMax) * ph;

  const line = points
    .map((v, i) => `${i === 0 ? 'M' : 'L'}${xp(i).toFixed(1)},${yp(v).toFixed(1)}`)
    .join(' ');
  const area = `${line} L${xp(n - 1).toFixed(1)},${(PAD.t + ph).toFixed(1)} L${xp(0).toFixed(1)},${(PAD.t + ph).toFixed(1)} Z`;

  const ticks = [0, 25, 50, 75, 100].filter((t) => t <= yMax);
  const last = points[n - 1];
  const lastColor = unit === '%' ? (last >= 90 ? '#ef4444' : last >= 75 ? '#f59e0b' : color) : color;
  const fmtX = (ts) => new Date(ts).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  const xTicks = n > 1 ? [0, Math.floor((n - 1) / 2), n - 1] : [0];

  // Couleurs thème-relatives
  const grid = 'rgb(var(--c-rule))';
  const muted = 'rgb(var(--c-muted-3))';

  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-[130px] block">
      {ticks.flatMap((t) => [
        <line
          key={`gl${t}`}
          x1={PAD.l}
          y1={yp(t)}
          x2={PAD.l + pw}
          y2={yp(t)}
          stroke={grid}
          strokeWidth={1}
          strokeDasharray={t === 0 ? 'none' : '3,4'}
        />,
        <text
          key={`yt${t}`}
          x={PAD.l - 6}
          y={yp(t) + 4}
          textAnchor="end"
          fontSize={10}
          fill={muted}
          fontFamily="monospace"
        >{`${t}${unit || '%'}`}</text>,
      ])}
      <text
        x={11}
        y={H / 2 + 4}
        fontSize={10}
        fill={muted}
        textAnchor="middle"
        transform={`rotate(-90,11,${H / 2})`}
      >
        {yLabel}
      </text>
      <path d={area} fill={color} opacity={0.13} />
      <path
        d={line}
        fill="none"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={xp(n - 1)} cy={yp(last)} r={3.5} fill={lastColor} />
      <text
        x={xp(n - 1) + 8}
        y={yp(last) + 4}
        fontSize={11}
        fill={lastColor}
        fontWeight="bold"
        fontFamily="monospace"
      >{`${last.toFixed(1)}${unit || '%'}`}</text>
      <line x1={PAD.l} y1={PAD.t + ph} x2={PAD.l + pw} y2={PAD.t + ph} stroke={grid} strokeWidth={1} />
      {timestamps &&
        xTicks.map((i) => (
          <text
            key={`xt${i}`}
            x={xp(i)}
            y={PAD.t + ph + 14}
            textAnchor="middle"
            fontSize={9}
            fill={muted}
            fontFamily="monospace"
          >
            {fmtX(timestamps[i])}
          </text>
        ))}
    </svg>
  );
}
